import { SegmentFragment, CheckinSegmentFragment } from '@websky/graphql';
import { ServiceOptionItem } from '../../../ServiceSummary/types';
import { TravellerInfo } from '../../../types';
import { CartGroupOptionAdapterType } from '../../../Cart/CartItemOptionAdapter/CartItemOptionAdapter';
import { groupServiceOptionsBySegment } from '@shared/lib/gdsService';
import { ALL_SEGMENTS_KEY } from '@shared/lib/flight';
import { ServiceSummaryType } from '../model/types';

export function optionGroupsFactory({
	key,
	items,
	segments,
	traveller,
	gdsServiceType
}: {
	key: string;
	items: ServiceOptionItem[];
	segments: (SegmentFragment | CheckinSegmentFragment)[];
	traveller: TravellerInfo;
	gdsServiceType: ServiceSummaryType;
}): CartGroupOptionAdapterType | CartGroupOptionAdapterType[] {
	const isAllSegments = key === ALL_SEGMENTS_KEY;
	const segment = !isAllSegments ? segments.find(segment => segment.id === key) : null;

	switch (gdsServiceType) {
		case 'Seat':
		case 'Meal':
		case 'Upgrade':
			return {
				items,
				traveller,
				headerType: 'travellerName'
			};
		case 'Misc':
			return {
				items,
				traveller,
				headerType: 'travellerName',
				allSegments: isAllSegments,
				direction: segment
			};
		case 'BusinessLounge':
		case 'CapsuleHotel':
		case 'PriorityBoarding':
			return {
				items,
				traveller,
				allSegments: isAllSegments,
				headerType: 'travellerName',
				direction: segment
			};
		case 'Baggage':
		case 'Animal':
		case 'Transfer':
			return groupServiceOptionsBySegment({ items, segments, traveller });
		case 'Sms':
			return {
				items: items.map(item => ({
					...item,
					name: traveller.name
				}))
			};
		case 'RefundableTicket':
			return {
				items,
				traveller,
				headerType: 'serviceName'
			};
		default:
			return null;
	}
}
